// extracted by mini-css-extract-plugin
export var createdDate = "_gg-1";
export var divider = "_gg-2";
export var headerDivider = "_gg-3";
export var messagesCard = "_gg-0";
export var messagesContainer = "_gg-7";
export var messagesContainerWrapper = "_gg-4";
export var pointerCapturingButtonBoxes = "_gg-a";
export var showLeftPanelButton = "_gg-9";
export var showMoreButton = "_gg-c";
export var showMoreButtonContainer = "_gg-b";
export var summaryTitle = "_gg-6";
export var systemMessageCardWrapper = "_gg-d";
export var topButtons = "_gg-8";
export var withPadding = "_gg-5";